import React from 'react';
import { IChallengeItem } from 'services/casino';

const order = (c: IChallengeItem, now: Date): number => {
  const isCompleted = c.active === false || (!!c.endDate && now > new Date(c.endDate));
  if (isCompleted) return 2;
  const status = c.participantStatus?.toLowerCase();
  if (status === 'enrolled' || c.joined) return 1;
  return 0; // pending
};

export const useSortedFeaturedItems = (featuredItems: IChallengeItem[]): IChallengeItem[] => {
  return React.useMemo(() => {
    const now = new Date();
    return [...featuredItems].sort((a, b) => order(a, now) - order(b, now));
  }, [featuredItems]);
};
